import { REFRIGERANT_OPTIONS } from 'data/constants';

// refrigerantFamilySupport persists as a plain string in the catalog's
// bracketed format ('[R-410A],[R-32]'). These helpers are the only
// string↔array boundary (AHA-6681 spec-field reorg): the multiselect input
// works with arrays, everything else keeps the string.

const canonicalByUpper = new Map(
  REFRIGERANT_OPTIONS.map((option) => [option.toUpperCase(), option])
);

// Lenient parse: accepts the bracketed catalog format and plain comma-joined
// values, in any order/casing. Tokens outside REFRIGERANT_OPTIONS (e.g.
// 'A1 only') are dropped. Returns canonical values in REFRIGERANT_OPTIONS
// order; null/empty/garbage input yields [].
export function parseRefrigerantFamilySupport(raw: unknown): string[] {
  if (typeof raw !== 'string' || raw.trim() === '') {
    return [];
  }
  const matched = new Set<string>();
  raw.split(',').forEach((token) => {
    const bare = token.trim().replace(/^\[/, '').replace(/\]$/, '').trim();
    const canonical = canonicalByUpper.get(bare.toUpperCase());
    if (canonical) {
      matched.add(canonical);
    }
  });
  return REFRIGERANT_OPTIONS.filter((option) => matched.has(option));
}

// Serialize back to the catalog format: dedupe, drop unknowns, order by
// REFRIGERANT_OPTIONS, bracket each value. An empty selection serializes to
// '' so isEmpty drops the field from save payloads.
export function serializeRefrigerantFamilySupport(values: string[]): string {
  const selected = new Set(values);
  return REFRIGERANT_OPTIONS.filter((option) => selected.has(option))
    .map((option) => `[${option}]`)
    .join(',');
}
